<template>
  <div class="container-fluid h-100">
    <div class="container mt-5 pt-5">

        <div class="row mt-5 pt-3">
            <div class="col-12">
            <h4 class="text-left text-dark font-weight-bold">
              Total de productos activos: {{ this.totalActiveItems }}
            </h4>
            </div>
             <div class="col-12">
            <h4 class="text-left text-dark font-weight-bold">
              Total de productos inactivos: {{ this.totalInactiveItems }}
            </h4>
            </div>
            <div class="col-5 mt-2">
            <input
                v-model="searchN"
                type="text"
                class="form-control"
                id="exampleFormControlInput1"
                placeholder="Buscar producto"
                autocomplete="off"
                style="text-transform: uppercase;"
                v-on:focus="clearInput"
            />
            </div>            
            <div class="col-1 mt-2">
            <button class="btn btn-danger btn-block" @click="getProducts()">
              <i class="fa fa-search m-0 p-0" aria-hidden="true"></i>
            </button>
            </div>
            <div class="col-3 mt-2">
            <button class="btn btn-info btn-block" @click="downloadReport()">
              Descargar reporte
            </button>
            </div>
        </div>

      <template v-if="loading.history">
        <div class="d-flex justify-content-center">
          <div
            class="spinner-border text-danger"
            style="width: 4em; height: 4rem;"
            role="status"
          ></div>
        </div>
      </template>

      <div class="row mt-1">
        <div class="col-12">
          <div class="table-responsive">
            <table class="table table-striped table-sm">
              <thead>
                <tr>
                  <th scope="col" style="text-align: left">SKU</th>
                  <th scope="col" style="text-align: left">Imagen</th>
                  <th scope="col" style="text-align: left">Nombre</th>
                  <th scope="col" style="text-align: left">Estado</th>
                  <th scope="col" style="text-align: left">Stock</th>
                  <th scope="col" style="text-align: left">Redenciones</th>
                  <th scope="col" style="text-align: left">Acción</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in items.slice((currentPage - 1) * pageSize, currentPage * pageSize)" :key="item.id"
                >
                  <td style="text-align: left">
                    {{ item.sku }}
                  </td>
                  <td style="text-align: left">
                    <img
                      width="100"
                      class="img-item"
                      :src="item.img"
                      :alt="item.name"
                    />
                  </td>
                  <td style="text-align: left">
                    {{ item.name }}
                    <i
                      class="fa fa-info-circle text-info ml-1"
                      style="font-size: 20px;"
                      aria-hidden="true"
                      data-bs-toggle="tooltip"
                      data-bs-placement="bottom"
                      :title="item.description"
                    ></i>
                  </td>
                  <td style="text-align: left">
                    {{ item.estado }}
                  </td>
                  <td style="text-align: left">
                    <h6>
                      <span class="badge badge-pill badge-danger">
                        {{ item.realStock }}
                      </span>
                    </h6>
                  </td>
                  <td style="text-align: left">
                    <label @click="getRedemptions(item)" v-if="item.status_id == 1" style="color: #dc3545; cursor:pointer;">
                      <i class="fa fa-duotone fa-eye"></i>
                      Ver redenciones
                    </label>
                    <label @click="getRedemptions(item)" v-else style="color: gray; cursor:pointer;">
                      <i class="fa fa-duotone fa-eye"></i>
                      Ver redenciones
                    </label>
                  </td>
                  <td style="text-align: left">
                    <button
                      @click="editProduct(item.id)"
                    >
                      Editar
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Paginación -->
      <div style="margin:25px 5px 5px 5px;" class="d-flex justify-content-center">
        <nav aria-label="Page navigation example">
          <ul class="pagination">
            <li class="page-item" :class="{disabled: currentPage === 1}">
              <a class="previous page-link" href="#" @click.prevent="prevPage()">
                <
              </a>
            </li>
            <li class="page-item" v-for="page in pages" :key="page" :class="{active: currentPage === page}">
              <a class="page-link" href="#" @click.prevent="changePage(page)">
                {{ page }}
              </a>
            </li>
            <li class="page-item" :class="{disabled: currentPage === totalPages}">
              <a class="next page-link" href="#" @click.prevent="nextPage()">
                >
              </a>
            </li>
          </ul>
        </nav>
      </div>

    </div>
  </div>
</template>

<script>
// import $ from "jquery";
import * as XLSX from 'xlsx';
import axios from 'axios';

export default {
  data() {
    return {
      totalActiveItems:0,
      totalInactiveItems:0,
      searchN: "Buscar producto",
      loading: {
        history: false,
        order: false
      },
      items: [],

      // Paginación
      currentPage: 1,
      pageSize: 10,
      totalDatos: 0,
      totalPages: 0,
      paginatedData: [],
      paginationVisible: true,
    };
  },
  computed: {
    pages() {
      const pages = [];
      const limit = this.totalPages > 5 ? 5 : this.totalPages;
      let start = this.currentPage - 2;
      if (start <= 0) start = 1;
      let end = start + limit - 1;
      if (end > this.totalPages) {
        end = this.totalPages;
        start = end - limit + 1;
        if (start <= 0) start = 1;
      }
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },
  },
  methods: {
    getRedemptions(item){
      this.$router.push({ name: "listProductRedemptions", params: { productId: item.id, productName: item.name, productSku:item.sku } });        
    },
    getProducts() {
      this.items = [];
      this.totalActiveItems = 0;
      this.totalInactiveItems = 0;
      this.loading.history = true;
      axios
        .get(`api/moto/stock/listStock/${this.searchN == 'Buscar producto' || this.searchN == '' ? '0' : this.searchN}`)
        .then(res => {
          if (res.data.cod == 0) {
            res.data.data.forEach(element => {
              if(element.sku === null){
                this.items.push(element)
                this.totalDatos = this.items.length;
                this.totalPages = Math.ceil(this.totalDatos / this.pageSize);
                this.items.sort((a, b) => {
                  return a.name.localeCompare(b.name);
                });
                this.paginated();
              }else{
                if(!element.sku.includes("BONO")){
                  this.items.push(element)
                  this.totalDatos = this.items.length;
                  this.totalPages = Math.ceil(this.totalDatos / this.pageSize);
                  this.items.sort((a, b) => {
                    return a.name.localeCompare(b.name);
                  });
                  this.paginated();
                }
              }
            });
          }
          this.items.map(item => {
            let realStock = 0;
            item.product_size.map(size => {
              realStock = realStock + parseInt(size.availability)
            });
            item.realStock = realStock
            if(item.status.id == 1){
              item.estado = 'Activo'
              this.totalActiveItems++
            }else{
              item.estado = 'Inactivo'
              this.totalInactiveItems++
            }
          });
          
          this.loading.history = false;
        })
        .catch(() => {
          this.loading.history = false;          
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: "Error al traer la información"
          });
        });
    },
    downloadReport(){
      this.arrayProducts = [];
      this.items.forEach((item) => {
        this.arrayProducts.push({
          Id: item.id,
          Sku: item.sku,
          Nombre: item.name,
          Estado: item.estado,
          Cantidad: item.realStock
        });
      });
      // console.log('this.arrayProducts: ', this.arrayProducts);
      const data = XLSX.utils.json_to_sheet(this.arrayProducts);
      const workbook = XLSX.utils.book_new();
      const filename = 'ReporteStock';
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename}.xlsx`);
    },
    clearInput() {
      this.searchN = "";
    },
    editProduct(id){
      console.log('id del producto ', id);
      this.$router.push("/admin/products/edit/" + id);
    },

    // Paginación
    paginated() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      this.paginatedData = this.items.slice(start, end);
    },
    changePage(page) {
      this.currentPage = page;
      this.paginated();
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.paginated();
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.paginated();
      }
    },
    changeSize(size) {
      this.pageSize = size;
      this.totalPages = Math.ceil(this.totalDatos / this.pageSize);
      this.currentPage = 1;
      this.paginated();
    },
    // Fin paginación
  },
  mounted() {
    this.getProducts();
  },
  watch: {
    // searchN: function(newN) {
    //   if (!newN) {
    //     setTimeout(() => this.getProducts(), 15000);
    //   }
    // },
    "form.name": function(newV) {
      if (!newV) {
        this.errors.name = "El nombre del producto es requerido.";
      } else {
        this.errors.name = false;
      }
    },
    "form.description": function(newV) {
      if (!newV) {
        this.errors.description = "La descripción del producto es requerida.";
      } else {
        this.errors.description = false;
      }
    },
    "form.points": function(newV) {
      if (!newV) {
        this.errors.points = "La cantidad de puntos es requerida.";
      } else {
        this.errors.points = false;
      }
    },
    "form.price": function(newV) {
      if (!newV) {
        this.errors.price = "El precio del producto es requerido.";
      } else {
        this.errors.price = false;
      }
    },
    "form.status": function(newV) {
      if (!newV) {
        this.errors.status = "El estado del producto es requerido.";
      } else {
        this.errors.status = false;
      }
    },
    "form.urlImg": function(newV) {
      if (!newV) {
        this.errors.urlImg = "La imagen del producto es requerida.";
      } else {
        this.errors.urlImg = false;
      }
    }
  }
};
</script>

<style scoped>
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
  overflow: hidden;
}
.container{
  max-width: 95%;
}
.div-button {
  margin-top: 50px;
  text-align: left;
}
.is-danger {
  border: solid 2px !important;
  border-color: #e9434c !important;
}
.modal-title {
  color: black;
  font-weight: bold;
}
.modal-question {
  border: solid 3px;
  border-color: #dc3545;
  border-radius: 15px;
}
label {
  color: black;
  margin-right: 4px;
}
.img-banner {
  display: block;
  width: 25%;
  text-align: center;
  margin: auto;
}
td {
  text-align: center;
  vertical-align: -webkit-baseline-middle;
  cursor: all-scroll;
}
.table-container {
  overflow: auto;
}
h5 {
  margin-bottom: 10px !important;
}
.commentary {
  text-align: left;
  color: #1da5df;
  font-size: 13px;
}
.page-item.active .page-link {
  border-style: none;
  border-radius: 20px;
  background-color: #dc3545;
}
a.page-link {
  color: black;
  cursor: pointer;
}
a.page-link:hover {
  color: #dc3545;
}
.page-link {
  background-color: #f5f5dc00;
  border-radius: 20px;
  border-color: none;
}
.page-item.disabled .page-link {
  color: #dc3545;
  background-color: #fff0;
  border-color: #dee2e600;
}
.ul-pagination {
  padding: 0px;
}
.previous{
  color:#0056b3 !important;
  border-radius: 20px 0px 0px 20px !important;
  margin-right: 5px;
}
.next{
  color:#0056b3 !important;
  border-radius: 0px 20px 20px 0px !important;
}
.page-link {
  border-color: none;
  margin-right: 5px;
}
.page-item.active .page-link {
  border-style: none;
  background-color: #dc3545;
}
.page-item.disabled .page-link {
  color: #dc3545;
}
</style>
